"use client";

import { AppProgressProvider } from "@bprogress/next";

export function NgProgress({ children }: { children: React.ReactNode }) {
  return (
    <AppProgressProvider
      height="2px"
      color="var(--primary)"
      options={{ showSpinner: false }}
      shallowRouting
    >
      {children}
    </AppProgressProvider>
  );
}
